module.exports = __webpack_public_path__ + "img/scan-code.3996ea67.svg";